import type { Dispatch, SetStateAction } from 'react';

import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { CaretLeft, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import Lightbox, { ImagesListType } from 'react-spring-lightbox';

import { Header } from './components/Header';

type Props = {
    readonly currentImageIndex: number;
    readonly images: ImagesListType;
    readonly isOpen: boolean;
    readonly onClose: () => void;
    readonly setImageIndex: Dispatch<SetStateAction<number>>;
    readonly testid?: string;
};

export const AttachmentLightbox = ({
    currentImageIndex,
    images,
    isOpen,
    onClose,
    setImageIndex,
    testid = 'messengerAttachmentLightBox',
}: Props) => {
    const gotoPrevious = () => {
        const canPrev = currentImageIndex > 0;
        if (canPrev) {
            setImageIndex((state) => state - 1);
        } else {
            setImageIndex(images.length - 1);
        }
    };

    const gotoNext = () => {
        const canNext = currentImageIndex < images.length - 1;
        if (canNext) {
            setImageIndex((state) => state + 1);
        } else {
            setImageIndex(0);
        }
    };

    return (
        <div data-testid={testid}>
            <Lightbox
                className="bg-white [&_img]:cursor-zoom-in"
                currentIndex={currentImageIndex}
                images={images}
                isOpen={isOpen}
                onClose={onClose}
                onNext={gotoNext}
                onPrev={gotoPrevious}
                renderHeader={() => (
                    <Header
                        currentImageIndex={currentImageIndex}
                        galleryLength={images.length}
                        galleryTitle={`Attachment ${currentImageIndex + 1}`}
                        onClose={onClose}
                    />
                )}
                renderNextButton={() => (
                    <IconButton
                        className="absolute right-sm z-10 xsMax:hidden"
                        icon={CaretRight}
                        iconStyle="bold"
                        onClick={gotoNext}
                        variant="outlined"
                    />
                )}
                renderPrevButton={() => (
                    <IconButton
                        className="absolute left-sm z-10 xsMax:hidden"
                        icon={CaretLeft}
                        iconStyle="bold"
                        onClick={gotoPrevious}
                        variant="outlined"
                    />
                )}
                singleClickToZoom
            />
        </div>
    );
};
